import styled from 'styled-components'

export const Description = styled('p')`
  font-size: 16px;
  font-weight: normal;
  margin: 0px;
`